var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalletLineIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7c1.1 0 2 .787 2 1.75v9.5c0 .962-.9 1.75-2 1.75H4c-1.1 0-2-.788-2-1.75V5.5M20 7H4a2 2 0 01-2-2v0a2 2 0 012-2h6.5M20 7V5a2 2 0 00-2-2h-2m5.5 9h-2a1.5 1.5 0 00-1.5 1.5v0a1.5 1.5 0 001.5 1.5h2",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7l10.211-5.106a2 2 0 012.683.895L18 7",
    stroke: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLineIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDdDMjEuMSA3IDIyIDcuNzg3NSAyMiA4Ljc1VjE4LjI1QzIyIDE5LjIxMjUgMjEuMSAyMCAyMCAyMEg0QzIuOSAyMCAyIDE5LjIxMjUgMiAxOC4yNVY1LjVNMjAgN0gxOUg0QzIuODk1NDMgNyAyIDYuMTA0NTcgMiA1VjVDMiAzLjg5NTQzIDIuODk1NDMgMyA0IDNIMTAuNU0yMCA3VjVDMjAgMy44OTU0MyAxOS4xMDQ2IDMgMTggM0gxNk0yMS41IDEySDE5LjVDMTguNjcxNiAxMiAxOCAxMi42NzE2IDE4IDEzLjVWMTMuNUMxOCAxNC4zMjg0IDE4LjY3MTYgMTUgMTkuNSAxNUgyMS41IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMgN0wxMy4yMTExIDEuODk0NDNDMTQuMTk5MSAxLjQwMDQ1IDE1LjQwMDQgMS44MDA5IDE1Ljg5NDQgMi43ODg4NUwxOCA3IiBzdHJva2U9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };